import { newE2EPage } from '@stencil/core/testing';

describe('salla-products-slider', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<salla-products-slider></salla-products-slider>');

    const element = await page.find('salla-products-slider');
    expect(element).toHaveClass('hydrated');
  });
});
